import React from "react";

const PaymentDue = () => {
  return (
    <div className="flex flex-col w-full">
    
        <div className="flex">

        </div>
      <div className="flex flex-col w-full p-10">
        <div
          id="head"
          style={{ height: 350 }}
          className="flex w-full text-xl font-extrabold"
        >
          <div>$25.00</div>
        </div>
        <div id="body">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th
                  style={{ width: 30 }}
                  className=" text-left py-3  uppercase font-semibold text-sm"
                >
                  #No
                </th>

                <th className=" text-center py-3 px-2 uppercase font-semibold text-sm">
                  DESCRIPTION
                </th>
                <th
                  style={{ width: 30 }}
                  className=" text-center py-3  uppercase font-semibold text-sm"
                >
                  QTY
                </th>

                <th className="text-right py-3 px-2 uppercase font-semibold text-sm">
                  PRICE USD
                </th>

                <th className="text-center py-3 px-2 uppercase font-semibold text-sm">
                  SUB TOTAL USD
                </th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              <tr>
                <td>01</td>
                <td>SHIMLA GEM - BACK-END SERVER CHARGE</td>
                <td>1</td>
                <td>25</td>
                <td>25</td>
              </tr>
              <tr>
                <td>01</td>
                <td>SHIMLA GEM - FRONT-END SERVER CHARGE</td>
                <td>1</td>
                <td>25</td>
                <td>25</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PaymentDue;
